import React, { useEffect, useRef, useState } from 'react';
import { Alert, Button, Snackbar } from '@mui/material';
import * as serviceWorkerRegistration from '../serviceWorkerRegistration';

function ServiceWorkerUpdatePrompt() {
  const [registration, setRegistration] = useState(null);
  const reloadingRef = useRef(false);

  useEffect(() => {
    serviceWorkerRegistration.register({
      onUpdate: (updatedRegistration) => {
        setRegistration(updatedRegistration);
      },
    });
  }, []);

  const handleUpdate = () => {
    const waitingWorker = registration?.waiting;
    if (!waitingWorker) {
      return;
    }

    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (reloadingRef.current) {
        return;
      }
      reloadingRef.current = true;
      window.location.reload();
    });

    waitingWorker.postMessage({ type: 'SKIP_WAITING' });
  };

  return (
    <Snackbar
      open={Boolean(registration?.waiting)}
      autoHideDuration={null}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
    >
      <Alert
        severity="info"
        action={(
          <Button color="inherit" size="small" onClick={handleUpdate}>
            Atualizar
          </Button>
        )}
        sx={{
          boxShadow: 'none',
          border: '1px solid currentColor',
        }}
      >
        Nova versão disponível
      </Alert>
    </Snackbar>
  );
}

export default ServiceWorkerUpdatePrompt;
